var path = 'src/app/components/common/sql-editor/sql-editor.template.html';
var html = "<textarea></textarea>\n<div class=\"error\" ng-if=\"!$ctrl.isInitialized\">\n  SQL editor failed to load\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;